import React from 'react';

const SmashLoader = ({ className = 'h-screen', description = '' }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center bg-transparent text-blue-950 dark:text-white dark:bg-gray-900 ${className}`}
    >
      <p className="text-4xl font-poppins font-bold flex items-baseline">
        smash
        <span className="ml-1 flex space-x-1">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="animate-bounce inline-block font-bold"
              style={{
                animationDelay: `${i * 0.2}s`,
                animationDuration: '0.6s',
              }}
            >
              .
            </span>
          ))}
        </span>
      </p>
      {description && <p className="text-sm text-gray-500">{description}</p>}
    </div>
  );
};

export default SmashLoader;
